import {colors} from "@c10h/colors";
import {FilterType} from "@components/LocationMapForLocations";
import RadioDropdown from "@components/RadioDropdown";
import RegionTreeSelector from "@components/Region/RegionTreeSelector";
import router from "next/router";
import {useTranslation} from "ni18n";
import React, {useCallback} from "react";
import {v5Pages} from "src/components/_common/_constants";
import {useTypedSelector} from "src/store";
import useMediaQuery from "src/useMediaQuery";

import {SpecialtyId} from "../../../constants/specialtyIds";
import {setSkipFitBoundsOnLocationRouteChange} from "../../../utils/browser-storage/skipFitBoundsOnLocationsRouteChange";

type Props = {
  // @ts-expect-error TS7008: Member 'getToggleFilterHandler' implicitly has an 'any' type.
  getToggleFilterHandler;
  // @ts-expect-error TS7008: Member 'filters' implicitly has an 'any' type.
  filters;
  // @ts-expect-error TS7008: Member 'isFilterActive' implicitly has an 'any' type.
  isFilterActive;
  // @ts-expect-error TS7008: Member 'locate' implicitly has an 'any' type.
  locate;
};

const MapOptions: React.FC<Props> = ({getToggleFilterHandler, filters, isFilterActive, locate}) => {
  const i18n = useTranslation();

  const isSm = useMediaQuery("sm");

  const {locations} = useTypedSelector(state => state.config);

  const filterButtonData = locations
    .flatMap(l => l.specialties.vals())
    .distinctBy("id")
    .filter(s => s.id !== SpecialtyId.ORTHOPEDICS)
    .sortBy("sortIndex")
    .map(s => ({
      func: filters.specialtyId(s.id),
      name: s.name,
      sId: s.id,
      typ: FilterType.SPECIALTY,
    }));

  const options = filterButtonData.map(f => ({
    text: f.name,
    value: f,
    selected: isFilterActive(f),
  }));

  // @ts-expect-error TS7006: Parameter 'value' implicitly has an 'any' type.
  const onSelect = value => {
    getToggleFilterHandler(value)();
  };

  const onRegionSelect = useCallback((slug: string) => {
    router.replace(
      {pathname: v5Pages.locations, query: {...router.query, region: slug}},
      undefined,
      {
        shallow: true,
      },
    );

    if (router.query.slug && router.query.city) {
      // local storage flag for skipping google maps moving to current location on load
      setSkipFitBoundsOnLocationRouteChange(true);

      router.push({pathname: v5Pages.locations}, undefined, {
        shallow: true,
      });
    }
  }, []);

  const isXs = useMediaQuery("xs");

  return (
    <div
      className="p-1 md:p-4 contrast-tbb bg-white"
      style={{boxShadow: `0px 1px 1px 0px ${colors.gray800 + 10}`}}
    >
      <div className={`flex flex-wrap justify-between gap-1 w-full`}>
        <div className="flex flex-nowrap gap-1 items-center grow">
          <RegionTreeSelector buttonVariant="locations" hideVirtualOnly onSelect={onRegionSelect} />
          <button
            className="flex items-center aibl font-c font-i-sm bg-gray50 gray600 hover-gray800 brd1nc brd-gray100 br2 fs18 fs14-sm cp p-3 sm:p-4"
            onClick={locate}
          >
            <span className="cIcon-locArrow jcc aic fs14" aria-hidden />
            <span className="hidden sm:flex ml2">{i18n.t("Locate Me")}</span>
          </button>
        </div>
        <RadioDropdown
          text={i18n.t("Filters")}
          options={options}
          onSelect={onSelect}
          variant={isSm ? "square" : "round"}
          anchor={!isSm && isXs ? "bottom center" : "bottom left"}
        />
      </div>
    </div>
  );
};

export default MapOptions;
